import { render } from "./CadastroCancelado.vue?vue&type=template&id=1c093215&scoped=true"
import script from "./CadastroCancelado.vue?vue&type=script&lang=js"
export * from "./CadastroCancelado.vue?vue&type=script&lang=js"

import "./CadastroCancelado.vue?vue&type=style&index=0&id=1c093215&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c093215"]])

export default __exports__